<template>
  <form id="orderForm" action="/cart" method="POST">
    <input type="hidden" name="_token" :value="csrfToken">
    <input type="hidden" name="purchase" value="yes">
    <div class="row">
      <div class="mb-4 align-items-center">
        <div class="card col-xl-12 mt-1">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  {{ $t("Product") }}
                </th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  {{ $t("Product") }}
                </th>
                <th class="text-uppercase text-center text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                  {{ $t("Quantity") }}
                </th>
                <th
                  class="text-center text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 d-none d-md-table-cell">
                  {{ $t("RRP") }} ({{ $t("gross") }})
                </th>
                <th
                  class="text-center text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 d-none d-md-table-cell">
                  {{ $t("Discount Tier") }}
                </th>
                <th class="text-center text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  {{ $t("PO price") }} ({{ $t("net") }})
                </th>
                <th class="text-center text-end text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  {{ $t("Subtotal") }}
                </th>
              </tr>
            </thead>
            <tbody v-for="productGroup in productGroups">
              <tr>
                <td colspan="7" v-if="getGroupProducts(productGroup.id).length > 0">
                  <h4>{{ $t(productGroup.name) }}</h4>
                </td>
              </tr>
              <tr v-if="productGroup.id == 5" id="pos-section">
                <td colspan="7">
                  <div class="alert alert-success text-white text-wrap text-break w-75" role="alert">
                    <p>
                      Entdeckt unsere POS Materialien! Ergänzt eure Bestellungen mit Zusatz- und
                      Informationsmaterialien für eure Verkaufsflächen.
                    </p>
                    <p>
                      Ihr könnt pro Bestellung
                      <span v-if="currentPricingTier.name == '01'">ein kostenfreies POS Produkt</span>
                      <span v-else>bis zu drei kostenfreie POS Produkte</span>

                      hinzufügen. Natürlich könnt ihr auch gern
                      mehr POS Materialien darüber hinaus bestellen – dafür erheben wir eine Schutzgebühr von 1 € pro
                      Artikel sowie eine Versandkostenpauschale.
                    </p>
                  </div>
                </td>
              </tr>
              <tr v-if="productGroup.minQuantity > 0">
                <td colspan="7" class="text-wrap text-break">
                  <p class="text-wrap">
                    {{
                      $t("The minimum order quantity for the light carafes and adventure mounts is :quantity pieces in"
                        + " total (not per unit). You can freely choose the SKUs within the group.",
                        transReplacements({
                          quantity:
                            productGroup.minQuantity,
                        })
                      )
                    }}
                  </p>
                </td>
              </tr>
              <tr v-for="product in getGroupProducts(productGroup.id)">
                <td class="td-image d-flex justify-content-center align-items-center">
                  <img v-if="product.image" class="img-fluid w-30" :src="product.image + '_thumb.' + product.imageExt"
                    :alt="product.name" @error="onImageError">
                </td>
                <td class="text-wrap text-break">
                  <a :href="'/products/' + product.sku" class="productName" target="_blank">
                    <h6 class="mb-0">{{ product.name }}</h6>
                  </a>
                  <span class="tiny"><span v-if="product.description.length < 100" v-html="product.description" />
                    · SKU:
                    {{ product.sku.replace("-de", "")
                    }}<br>
                    <span v-if="product.deliveryInWeeksFrom !== undefined && product.deliveryInWeeksTo !== undefined">
                      {{ $t("Estimated delivery time") }}:
                      <span v-if="product.deliveryInWeeksFrom === 0 && product.deliveryInWeeksTo === 0"
                        class="delivery-available">{{ $t("immediately available") }}</span>
                      <span v-else-if="product.deliveryInWeeksFrom < 4 && product.deliveryInWeeksTo < 4"
                        class="delivery-indelivery">{{ $t("in delivery") }} ({{ product.deliveryInWeeksFrom }}
                        - {{ product.deliveryInWeeksTo }}
                        {{ $t("weeks") }})</span>
                      <span v-else-if="product.deliveryInWeeksFrom == product.deliveryInWeeksTo"
                        class="delivery-backordered">{{ $t("backordered") }} ({{ product.deliveryInWeeksFrom }}
                        {{ $t("weeks") }})
                      </span>
                      <span v-else class="delivery-backordered">{{ $t("backordered") }}
                        ({{ product.deliveryInWeeksFrom }} - {{ product.deliveryInWeeksTo }}
                        {{ $t("weeks") }})
                      </span>
                    </span>
                  </span>
                </td>
                <td>
                  <select v-model="quantities[product.sku]" :name="'quantities[' + product.sku + ']'"
                    class="form-select text-center">
                    <option v-for="i in product.availableQuantities" :value="i">
                      {{ i }}
                    </option>
                  </select>
                </td>
                <td class="text-center d-none d-md-table-cell">
                  {{ toCurrency(getUnitPrice(product, false)) }}
                </td>
                <td class="text-center d-none d-md-table-cell">
                  <a v-if="product.fixedNetPrice === null && product.excludedFromDiscounts === false"
                    class="badge badge-pill pricing-tier"
                    :class="quantities[product.sku] > 0 ? 'bg-gradient-success' : 'bg-gradient-secondary'"
                    data-bs-toggle="modal" data-bs-target="#pricingTiersModal" href="#">{{
                      getProductPricingTier(product).name }} ({{ getProductPricingTier(product).discount }}%)</a>
                  <a v-else-if="product.excludedFromDiscounts === false" class="badge badge-pill pricing-tier"
                    :class="quantities[product.sku] > 0 ? 'bg-gradient-success' : 'bg-gradient-secondary'"
                    data-bs-toggle="modal" data-bs-target="#pricingTiersNewProductsModal" href="#">{{
                      getDiscountForFixedNetPrice(
                        product.price,
                        product.fixedNetPrice
                      )
                    }}%</a>
                </td>
                <td class="text-center">
                  {{ toCurrency(getNetDiscountedUnitPrice(product)) }}
                </td>
                <td class="text-end">
                  {{ toCurrency(getNetDiscountedUnitPrice(product) * quantities[product.sku]) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="card mt-1">
          <div class="card-body p-2">
            <div class="row">
              <div class="col-md-5">
                {{ $t("Payment method") }}:
                <b>{{ showPaymentMethod }}</b>
              </div>
              <div class="col-md-4 col-8 text-end">
                {{ $t("Estimated delivery time") }}
              </div>
              <div v-if="totalQuantity > 0" class="col-md-3 col-4 text-end" v-html="orderDeliveryTime" />
            </div>

            <div class="row">
              <div class="col-md-9 col-8 text-end">
                {{ $t("Total quantity") }}
              </div>
              <div class="col-md-3 col-4 text-end">
                {{ totalQuantity }}
              </div>
            </div>
            <div class="row">
              <div class="col-md-9 col-8 text-end">
                {{ $t("Number of shipping boxes") }}
              </div>
              <div class="col-md-3 col-4 text-end">
                {{ boxQuantity }}
              </div>
            </div>
            <div class="row">
              <div class="col-md-9 col-8 text-end">
                {{ $t("Volume") }}
              </div>
              <div class="col-md-3 col-4 text-end">
                {{ toNumber(shippingVolume) }} cbm
              </div>
            </div>
            <div class="row">
              <div class="col-md-9 col-8 text-end">
                {{ $t("Gross weight") }}
              </div>
              <div class="col-md-3 col-4 text-end">
                {{ totalWeight }} kg
              </div>
            </div>

            <div class="row">
              <div class="col">
                <hr class="horizontal dark mt-lg-2">
              </div>
            </div>

            <div class="row">
              <div class="col-md-9 col-8 text-end">
                {{ $t("Total") }} {{ $t("RRP") }} ({{
                  $t("gross")
                }})
              </div>
              <div class="col-md-3 col-4 text-end">
                {{ toCurrency(getTotalMSRP) }}
              </div>
            </div>

            <div class="row">
              <div class="col-md-9 col-8 text-end">
                <a class="badge badge-pill badge-lg bg-gradient-success pricing-tier" data-bs-toggle="modal"
                  data-bs-target="#pricingTiersModal" href="#">{{ $t("Pricing Tier") }}</a>
              </div>
              <div class="col-md-3 col-4 text-end">
                <span class="text-success">{{ currentRealDiscount }}%</span>
              </div>
            </div>

            <div class="row">
              <div class="col-md-9 col-8 text-end">
                {{ $t("Total") }} {{ $t("PO price") }} ({{
                  $t("net")
                }})
              </div>
              <div class="col-md-3 col-4 text-end">
                {{ toCurrency(getTotalNetWithoutShipping) }}
              </div>
            </div>

            <div class="row mt-1">
              <div class="col-md-9 col-8 text-end">
                {{ $t("Shipping costs") }} ({{ $t("net") }})
              </div>
              <div class="col-md-3 col-4 text-end">
                <span v-if="palletShipping || shippingCosts === 0">{{ $t("On Request") }}</span>
                <span v-else>{{
                  toCurrency(shippingCosts)
                }}</span>
              </div>
            </div>

            <div v-if="miscDiscount > 0" class="row">
              <div class="col-md-9 col-8 text-end">
                {{ $t("Discount") }}
              </div>
              <div class="col-md-3 col-4 text-end green">
                -{{ toCurrency(miscDiscount) }}
              </div>
            </div>


            <div class="row">
              <div class="col-md-9 col-8 text-end">
                {{ $t("Total") }} ({{ $t("net") }})
              </div>
              <div class="col-md-3 col-4 text-end">
                {{ toCurrency(totalNetPrice) }}
              </div>
            </div>

            <div class="row">
              <div class="col-md-9 col-8 text-end">
                {{ $t("plus VAT") }} ({{ toNumber(taxRate) }}%)
              </div>
              <div class="col-md-3 col-4 text-end">
                {{ toCurrency(getTax(totalNetPrice)) }}
              </div>
            </div>


            <div class="row">
              <div class="col-md-9 col-8 text-end">
                <h6>{{ $t("Total") }} ({{ $t("gross") }})</h6>
              </div>
              <div class="col-md-3 col-4 text-end">
                <h6 class="text-decoration-underline">
                  {{ toCurrency(totalGrossPrice) }}
                  <span v-if="palletShipping">+ {{ $t("Shipping costs") }}</span>
                </h6>
              </div>
            </div>
          </div>
        </div>

        <div class="card mt-1">
          <div class="card-body p-2">
            <div class="row">
              <div class="col-lg-12">
                <h2>
                  {{
                    $t(
                      "Kindly provide necessary invoice notes, such as your company-internal order number, in this space."
                    )
                  }}
                </h2>
                <textarea class="form-control" name="invoice_text" />
              </div>
            </div>
          </div>
        </div>

        <div class="card mt-1">
          <div class="card-body p-2">
            <div class="row">
              <h2>{{ $t("Delivery and billing address") }}</h2>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <h3>{{ $t("Delivery address") }}</h3>
                <select class="form-control" name="shipping_address_id" required>
                  <option v-for="address in shippingAddresses" :value="address.id">
                    {{ address.address }}
                  </option>
                </select>
                <a href="/partner-account" class="tiny mt-1">{{
                  $t("Edit or create a new address")
                }}</a>
              </div>
              <div class="col-lg-6">
                <h3>{{ $t("Invoice address") }}</h3>
                <select class="form-control address" name="billing_address_id" required>
                  <option v-for="address in billingAddresses" data-content="ttt" :value="address.id">
                    {{ address.address }}
                  </option>
                </select>
                <a href="/partner-account" class="tiny mt-1">{{
                  $t("Edit or create a new address")
                }}</a>
              </div>
              <div class="col-lg-6 mt-3">
                <h3>{{ $t("Invoice email") }}</h3>
                {{ invoiceEmail }}
                <a href="/invoice-email" class="tiny mt-1">{{
                  $t("Edit or create a new address")
                }}</a>
              </div>
            </div>
          </div>
        </div>

        <div class="card mt-1">
          <div class="card-body p-2">
            <div class="row">
              <h2>{{ $t("Delivery settings & scheduling") }}</h2>
            </div>
            <div class="row">
              <div class="col-lg-5">
                <h3>{{ $t("Partial delivery") }}</h3>
                <div class="form-check">
                  <input v-model="partialDelivery" class="form-check-input" type="checkbox"
                    name="partial_shipping_allowed" value="1">
                  <label class="form-check-label" for="flexCheckDefault">
                    {{
                      $t(
                        "I agree to partial deliveries and may receive available goods more quickly."
                      )
                    }}
                  </label>
                </div>
              </div>
              <div class="col-lg-5 offset-lg-2">
                <h3>{{ $t("Scheduling") }}</h3>
                <div class="row">
                  <div class="col-lg-6">
                    {{ $t("Target delivery date") }}
                  </div>

                  <div class="col-lg-6">
                    <div class="form-check mt-1">
                      <input v-model="asap" class="form-check-input" type="checkbox" name="asap" value="1">
                      <label class="form-check-label" for="flexCheckDefault">
                        {{ $t("as soon as possible") }}
                      </label>
                    </div>
                    <DatePickerComponent name="earliest_shipping_date" v-model="earliestShippingDate"
                      :disabled="asap === true" />
                  </div>
                </div>
              </div>
              <div v-if="allowedPalletShipping" class="col-lg-5">
                <h3>{{ $t("Pallet shipping") }}</h3>
                <div class="form-check">
                  <input v-model="palletShipping" class="form-check-input" type="checkbox" name="pallet_shipping"
                    value="1">
                  <label class="form-check-label" for="flexCheckDefault">
                    {{ $t("I prefer pallet shipping") }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-1 text-end">
        <button type="button" class="btn btn-lg bg-gradient-success" @click="submitForm(false)">
          {{ $t("Order now") }}<br>
          <span v-if="!isExemptFromMinimumOrder && totalQuantity < MINIMUM_ORDER_QUANTITY" class="tiny fw-bold">{{ $t("Minimum order quantity")
            }}: {{ MINIMUM_ORDER_QUANTITY }}
            {{ $t("Pcs.") }}</span>
        </button>
      </div>
    </div>

    <div id="palletModal" ref="palletModalRef" class="modal fade" tabindex="-1" role="dialog"
      aria-labelledby="palletModal" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="palletModalLabel" class="modal-title">
              {{ $t("Pallet shipping") }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            {{
              $t("Due to the size of the order, would you like the package to be shipped on a"
                + " pallet? Information about shipping costs will be calculated later and sent"
                + " to you by e - mail"
              )
            }}
          </div>
          <div class="modal-footer">
            <button type="button" class="btn bg-gradient-primary" data-bs-dismiss="modal"
              @click="palletShipping = true">
              {{ $t("Yes") }}
            </button>
            <button type="button" class="btn bg-gradient-primary" data-bs-dismiss="modal"
              @click="palletShipping = false">
              {{ $t("No") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div id="confirmModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="confirmModal"
      aria-hidden="true" ref="confirmModalRef">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="confirmModalLabel" class="modal-title">
              {{ $t("Continue order process") }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            {{ $t("I accept the") }}
            <a href="https://sonnenglas.net/tos" target="_blank">{{
              $t("ToS")
            }}</a>
            {{
              $t(
                "and would like to continue the ordering process"
              )
            }}
          </div>
          <div class="modal-footer">
            <button type="button" class="btn bg-gradient-secondary" data-bs-dismiss="modal">
              {{ $t("No") }}
            </button>
            <button type="button" class="btn bg-gradient-primary" @click="confirmAndSubmitForm">
              {{ $t("Yes, order") }}
            </button>
          </div>
        </div>
      </div>
    </div>


    <div id="posModal" ref="posModalRef" class="modal fade" tabindex="-1" aria-labelledby="posModal" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t("Kostenlose POS-Materialien verfügbar") }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>
              {{ $t("Möchtet Ihr eurer Bestellung kostenfreies POS Material hinzufügen?") }}
            </p>
            <p>
              {{ $t("Anzahl der verbleibenden kostenlosen POS-Materialien:") }} {{ remainingFreePOSMaterials }}
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="submitForm(true)">
              {{ $t("No") }}
            </button>
            <button type="button" class="btn btn-primary" @click="scrollToPosMaterials">
              {{ $t("Ja, POS Material hinzufügen") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div id="posOnlyModal" ref="posOnlyModalRef" class="modal fade" tabindex="-1" aria-labelledby="posOnlyModal"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t("POS Material") }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>
              {{ $t("Seid Ihr sicher, dass Ihr nicht auch Sonnenglas® Produkte bestellen möchtet? POS "
                + "Materialien können entweder separat oder zur Ergänzung gewählt werden.") }}
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="confirmPosOnlyOrder">
              {{ $t("Nur POS Materialien") }}
            </button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal">
              {{ $t("Zurück zum Produktkatalog") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div id="preOrderModal" ref="preOrderModalRef" class="modal fade" tabindex="-1" aria-labelledby="preOrderModal"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t("Pre-Order Notice") }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>
              {{ $t("Your shopping cart contains products that are in pre-order status and will be delivered at "
                + "a later date. If your cart includes both available and pre-order items, two separate orders "
                + "will be created: one for available products and pre-order for pre-ordered items.") }}
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn bg-gradient-primary" data-bs-dismiss="modal">
              {{ $t("Agree") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div id="cannotOrderModal" ref="cannotOrderModalRef" class="modal fade" tabindex="-1" aria-labelledby="cannotOrderModal"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t("Order Not Possible") }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p v-if="totalQuantity === 0">
              {{ $t("Your cart is empty. Please add at least one product to place an order.") }}
            </p>
            <p v-else-if="totalQuantity < MINIMUM_ORDER_QUANTITY && !isExemptFromMinimumOrder">
              {{ $t("The minimum order quantity is :minimum pieces. You currently have :quantity items in your cart.",
                transReplacements({ minimum: MINIMUM_ORDER_QUANTITY, quantity: totalQuantity })) }}
            </p>
            <p v-else-if="!reachedMinimumForProductGroup">
              {{ $t("You have not reached the minimum order quantity for certain product groups. Please check the requirements above.") }}
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn bg-gradient-primary" data-bs-dismiss="modal">
              {{ $t("OK") }}
            </button>
          </div>
        </div>
      </div>
    </div>

  </form>
</template>

<script setup lang="ts">
import _ from "lodash";
import { ref, computed, watch, onMounted, nextTick } from "vue";
import { Modal } from "bootstrap";
import { Product, ProductGroup } from "@/types/product";
import { PricingTier } from "@/types/pricingTier";
import { Quantities } from "@/types/quantities";
import { getShippingData, getCartDeliveryPeriod } from "../libs/api";

import {
  toCurrency as toCurrencyFunc,
  toNumber,
  getTotalWeight,
  getTotalQuantity,
  getTotalGroupQuantity,
  getDeliveryTime,
  checkAllowedPalletShipping,
  didMetMinimumForProductGroup,
} from "../libs/utils";

import {
  getDefaultPricingTier,
  getPricingTier,
  getPriceBeforeDiscount,
  getNetPriceAfterDiscount,
  getDiscountForFixedNetPrice,
} from "../libs/discounts";

import { CartItem } from "@/types/cart";
import { ReplacementsInterface } from "@/types/replacements";
import DatePickerComponent from "./DatePickerComponent.vue";
import { ShortAddress } from "@/types/addresses";
import { trans } from "laravel-vue-i18n";

const PLACEHOLDER_IMAGE = "/images/placeholder.svg";

// Missing product photo: show the placeholder instead of a broken image
function onImageError(event: Event) {
  const img = event.target as HTMLImageElement;
  if (!img.src.endsWith(PLACEHOLDER_IMAGE)) {
    img.src = PLACEHOLDER_IMAGE;
  }
}

interface Props {
  products: Product[];
  productGroups: ProductGroup[];
  pricingTiers: PricingTier[];
  cart: CartItem[];
  currency: string;
  invoiceEmail: string;
  country: string;
  paymentMethod: string;
  csrfToken: string;
  taxRate: number;
  shippingAddresses: ShortAddress[];
  billingAddresses: ShortAddress[];
}

const props = defineProps<Props>();

const quantities = ref<Quantities>({});

const asap = ref(true);

const miscDiscount = ref(0);

const partialDelivery = ref(true);

const palletShipping = ref(false);

const shippingCosts = ref(0);

const boxQuantity = ref(0);

const shippingVolume = ref(0);

const alreadyShowedPalletShippingModal = ref(false);

const palletModalRef = ref<HTMLElement | null>(null);

const confirmModalRef = ref<HTMLElement | null>(null);

const posModalRef = ref<HTMLElement | null>(null);

const posOnlyModalRef = ref<HTMLElement | null>(null);

const preOrderModalRef = ref<HTMLElement | null>(null);

const cannotOrderModalRef = ref<HTMLElement | null>(null);

const earliestShippingDate = ref<string | null>(null);

const hasPreOrderProducts = ref(false);

const hasShownPreOrderModal = ref(false);

const cartDeliveryPeriod = ref<string | null>(null);

const isLoadingDelivery = ref(false);

const MINIMUM_ORDER_QUANTITY = 8;


props.products.forEach((product) => {
  quantities.value[product.sku] = 0;
});

const toCurrency = (price: number): string =>
  toCurrencyFunc(price, props.currency);

const showPaymentMethod = computed(() => {
  if (props.paymentMethod === "invoice") {
    return "auf Rechnung";
  } else {
    return "Vorkasse";
  }
});


const getTax = (price: number): number => {
  return (price * props.taxRate) / 100;
};

const getGroupProducts = (id: number): Product[] => {
  return props.products.filter((product) => product.group === id);
};

const getTotalNetWithoutShipping = computed((): number => {
  return props.products.reduce((total, product) => {
    return total + getNetDiscountedUnitPrice(product) * quantities.value[product.sku];
  }, 0);
});

const totalNetPrice = computed((): number => {
  return getTotalNetWithoutShipping.value + shippingCosts.value - miscDiscount.value;
});

const getTotalMSRP = computed((): number => {
  return props.products.reduce((total, product) => {
    return (
      total + getUnitPrice(product, false) * quantities.value[product.sku]
    );
  }, 0);
});

const totalGrossPrice = computed(() => {
  return totalNetPrice.value + getTax(totalNetPrice.value);
});

const allowedPalletShipping = computed(() => {
  if (checkAllowedPalletShipping(quantities.value)) {
    if (!alreadyShowedPalletShippingModal.value) {
      if (palletModalRef.value) {
        Modal.getOrCreateInstance(palletModalRef.value).show();
        alreadyShowedPalletShippingModal.value = true;
      }
    }
    return true;
  } else {
    palletShipping.value = false;
    alreadyShowedPalletShippingModal.value = false;
    return false;
  }
});

const totalQuantity = computed(() => {
  return getTotalQuantity(quantities.value);
});

const totalWeight = computed(() => {
  return getTotalWeight(props.products, quantities.value);
});

const currentPricingTier = computed(() => {
  return getDefaultPricingTier(props.pricingTiers, quantities.value, props.products);
});

const getProductPricingTier = (product: Product): PricingTier => {
  if (product.forcedPricingTier && product.forcedPricingTier.length) {
    return getPricingTier(props.pricingTiers, product.forcedPricingTier);
  }

  return currentPricingTier.value;
};

const reachedMinimumForProductGroup = computed((): boolean => {
  return didMetMinimumForProductGroup(quantities.value, props.productGroups, props.products);
});

const getNetDiscountedUnitPrice = (product: Product): number => {
  if (!product.price) {
    throw new Error("Product has no price:" + product.sku);
  }

  if (product.excludedFromDiscounts) {
    if (product.fixedNetPrice !== null) {
      return product.fixedNetPrice.value;
    }
    return product.price.value;
  }


  if (!product.price) {
    throw new Error("Product has no price:" + product.sku);
  }


  if (product.fixedNetPrice !== null) {
    return product.fixedNetPrice.value;
  }

  const productPricingTier = getProductPricingTier(product);

  return getNetPriceAfterDiscount(
    product.price,
    productPricingTier.discount,
    props.taxRate
  );
};

const getUnitPrice = (product: Product, netPricing: boolean): number => {
  return getPriceBeforeDiscount(product.price, props.taxRate, netPricing);
};

const currentRealDiscount = computed(() => {
  if (getTotalMSRP.value === 0) {
    return 0;
  }


  const discount = Math.round(100 * (getTotalMSRP.value - getTotalNetWithoutShipping.value) / getTotalMSRP.value);
  return discount;
});



const noAddressModal = new Modal("#noAddressModal");
if (props.shippingAddresses.length <= 0 && props.billingAddresses.length <= 0) {
  noAddressModal.show();
}

const transReplacements = (obj: {
  [key: string]: number | string;
}): ReplacementsInterface => {
  const result: ReplacementsInterface = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      result[key] = String(obj[key]);
    }
  }
  return result;
};


const orderDeliveryTime = computed(() => {
  if (isLoadingDelivery.value) {
    return '<span class="delivery-loading">' + trans("Loading...") + '</span>';
  }

  if (!cartDeliveryPeriod.value) {
    return '';
  }

  return cartDeliveryPeriod.value;
});



const calculateMiscDiscount = (): void => {
  console.log("Calculating misc discount");

  miscDiscount.value = 0;

  const freePosQuantity = currentPricingTier.value.name === "01" ? 1 : 3;

  let remainingFreePosQuantity = freePosQuantity;

  props.products.forEach((product) => {
    if (!product.isPos || !quantities.value[product.sku]) return;

    const quantity = quantities.value[product.sku];

    const freeForThisItem = Math.min(quantity, remainingFreePosQuantity);

    miscDiscount.value += getNetDiscountedUnitPrice(product) * freeForThisItem;

    remainingFreePosQuantity -= freeForThisItem;

    if (remainingFreePosQuantity <= 0) {
      return;
    }
  });

  // Ensure the discount value is rounded to 2 decimal places
  miscDiscount.value = parseFloat(miscDiscount.value.toFixed(2));
};

const updateShippingCosts = () => {
  getShippingData(quantities.value, props.country).then((res) => {
    shippingCosts.value = res.shippingCosts;
    boxQuantity.value = res.boxQuantity;
    shippingVolume.value = res.volume / 1000000000;
  });
};

const updateCartDeliveryPeriod = async () => {
  const hasItems = Object.values(quantities.value).some(quantity => quantity > 0);
  
  if (!hasItems) {
    cartDeliveryPeriod.value = null;
    return;
  }

  isLoadingDelivery.value = true;

  try {
    const response = await getCartDeliveryPeriod(quantities.value, props.country);
    
    if (response.delivery_period) {
      const start = new Date(response.delivery_period.start);
      const end = new Date(response.delivery_period.end);
      const now = new Date();
      
      // Calculate weeks from now
      const startWeeks = Math.max(0, Math.ceil((start.getTime() - now.getTime()) / (1000 * 60 * 60 * 24 * 7)));
      const endWeeks = Math.max(0, Math.ceil((end.getTime() - now.getTime()) / (1000 * 60 * 60 * 24 * 7)));
      
      if (startWeeks === 0 && endWeeks === 0) {
        cartDeliveryPeriod.value = '<span class="delivery-available">' + trans("immediately available") + '</span>';
      } else if (startWeeks < 4 && endWeeks < 4) {
        cartDeliveryPeriod.value = '<span class="delivery-indelivery">' + startWeeks + ' - ' + endWeeks + ' ' + trans("weeks") + '</span>';
      } else {
        cartDeliveryPeriod.value = '<span class="delivery-backordered">' + startWeeks + ' - ' + endWeeks + ' ' + trans("weeks") + '</span>';
      }
    }
  } catch (error) {
    console.error('Failed to fetch delivery period:', error);
    cartDeliveryPeriod.value = null;
  } finally {
    isLoadingDelivery.value = false;
  }
};

const updateFormCart = () => {
  props.cart.forEach((item) => {
    quantities.value[item.productSku] = item.quantity;
  });
};

const applyLaunchPromotion = () => {
  props.products.forEach((product) => {
    if ((product.group === 2 || product.group === 3) && quantities.value[product.sku] < 2) {
      quantities.value[product.sku] = 2;
    }
  });
};

const isPosOnlyOrder = computed(() => {
  return props.products.every(product =>
    quantities.value[product.sku] == 0 || product.isPos
  );
});

const isExemptFromMinimumOrder = computed(() => {
  return props.products.every(product =>
    quantities.value[product.sku] == 0 || product.isPos || product.group === 6
  );
});

const remainingFreePOSMaterials = computed(() => {
  if (isPosOnlyOrder.value) {
    return 0;
  }

  const freeItemsAllowed = currentPricingTier.value.name === "01" ? 1 : 3;
  const freeItemsSelected = props.products.reduce((count, product) => {
    if (product.isPos) {
      count += quantities.value[product.sku] || 0;
    }
    return count;
  }, 0);

  return Math.max(0, freeItemsAllowed - freeItemsSelected);
});

const confirmPosOnlyOrder = () => {
  const form = document.getElementById("orderForm") as HTMLFormElement;
  if (form) {
    form.submit();
  } else {
    console.error("Form not found");
  }
};

const submitForm = (forceSubmit: boolean = false) => {
  // Check if order cannot be placed
  const cannotOrder = totalQuantity.value === 0 || (!isExemptFromMinimumOrder.value && (totalQuantity.value < MINIMUM_ORDER_QUANTITY || !reachedMinimumForProductGroup.value));

  if (cannotOrder) {
    if (cannotOrderModalRef.value) {
      const cannotOrderModal = Modal.getOrCreateInstance(cannotOrderModalRef.value);
      cannotOrderModal.show();
    } else {
      console.error('Cannot order modal ref is not defined');
    }
    return;
  }

  if (isPosOnlyOrder.value) {
    console.log("POS-only order detected");

    if (posOnlyModalRef.value) {
      const posOnlyModal = Modal.getOrCreateInstance(posOnlyModalRef.value);
      posOnlyModal.show();
      return;
    } else {
      console.error("POS-only modal ref is not defined");
    }
  }

  // Check for free POS materials logic
  if (!forceSubmit && remainingFreePOSMaterials.value > 0) {

    if (posModalRef.value) {
      const posModal = Modal.getOrCreateInstance(posModalRef.value);
      posModal.show();
    } else {
      console.error('POS modal ref is not defined');
    }
    return;
  }

  // Show the confirm modal
  if (confirmModalRef.value) {
    const confirmModal = Modal.getOrCreateInstance(confirmModalRef.value);
    confirmModal.show();
  } else {
    console.error('Confirm modal ref is not defined');
  }
};

const showPreOrderModalIfNeeded = () => {
  // Pre-order functionality disabled as current API doesn't provide pre-order status
  const isNowPreOrder = false;

  // Show modal only when transitioning from 0 pre-order products → at least 1 pre-order product
  if (isNowPreOrder && !hasPreOrderProducts.value && !hasShownPreOrderModal.value) {
    hasPreOrderProducts.value = true;
    hasShownPreOrderModal.value = true; // Prevent re-showing

    if (preOrderModalRef.value) {
      const preOrderModal = Modal.getOrCreateInstance(preOrderModalRef.value);
      preOrderModal.show();
    }
  }
};


const confirmAndSubmitForm = () => {
  const form = document.getElementById("orderForm") as HTMLFormElement;
  if (form) {
    form.submit();
  } else {
    console.error('Form not found');
  }
};

const scrollToPosMaterials = async () => {
  const posModal = Modal.getInstance(posModalRef.value);
  if (posModal) {
    posModal.hide();
  }

  await nextTick();

  const posSection = document.querySelector("#pos-section");
  if (posSection) {
    posSection.scrollIntoView({ behavior: "smooth", block: "center" });
  } else {
    console.error("POS section not found");
  }

};

watch(
  () => _.cloneDeep(quantities.value),
  (currVal, prevVal) => {
    updateShippingCosts();
    calculateMiscDiscount();
    updateCartDeliveryPeriod();
    showPreOrderModalIfNeeded();
  },
  { deep: true }
);

watch(palletShipping, (currVal, prevVal) => {
  if (palletShipping.value) {
    shippingCosts.value = 0;
  } else {
    updateShippingCosts();
  }
});

onMounted(() => {
  updateFormCart();
  updateShippingCosts();
  updateCartDeliveryPeriod();

  if (palletModalRef.value) {
    Modal.getOrCreateInstance(palletModalRef.value);
  }

  if (posModalRef.value) {
    Modal.getOrCreateInstance(posModalRef.value);
  } else {
    console.error('posModalRef is not defined');
  }

  if (confirmModalRef.value) {
    Modal.getOrCreateInstance(confirmModalRef.value);
  }
});
</script>

<style scoped>
h2 {
  font-size: 1.3rem;
}

h3 {
  font-size: 1rem;
}

a.pricing-tier,
a.pricing-tier:hover {
  text-decoration: none;
  color: #fff;
}
</style>
<style>
.td-image {
  max-width: 200px;
  min-width: 100px;
}

.green {
  color: #2eaa2e
}

.productName:hover {
  text-decoration: underline;
}
</style>
